import React from 'react';
import { useOutletContext, Navigate } from 'react-router-dom';
import VoiceCallWidget from '../VoiceCall/VoiceCallWidget';
import { useAuth } from '../../contexts/AuthContext';

const DashboardHome = () => {
  const { selectedAssistant, setSelectedAssistant } = useOutletContext();
  const { userRole, loading } = useAuth();

  if (loading) {
    return null;
  }

  if (userRole === 'COACH' || userRole === 'coach') {
    return <Navigate to="/admin" replace />;
  }

  return (
    <div className="max-w-md mx-auto">
      <VoiceCallWidget 
        selectedAssistant={selectedAssistant} 
        isFloating={false}
      />
      {selectedAssistant && (
        <div className="mt-4 text-center">
          <button
            onClick={() => setSelectedAssistant(null)}
            className="text-sm text-gray-500 hover:text-gray-700 underline"
          >
            Clear selected assistant
          </button>
        </div>
      )}
    </div>
  );
};

export default DashboardHome;